enum routings {
  HOME = "/app/home",
  JOIN = "/app/join",
  MEETING = "/app/meeting",
  FEEDBACK = "/app/feedback",
  AUTHSCREEN = "/app/",
  WAITINGROOM = "/app/waitingroom",
  DASHBOARD = "/app/dashboard",
  SCHEDULE = "/app/dashboard/schedule",
  SCHEDULEMEETING = "/app/dashboard/meeting",
  CHAT = "/app/dashboard/chat",
  CALLS = "/app/dashboard/calls",
  PAST = "/app/dashboard/past-meetings",
  LIST = "/app/dashboard/chat/members",
  SEARCHRESULT = "/app/dashboard/search-result",
  WARNING = "/app/not-supported",
}
export default routings